module.exports = __webpack_public_path__ + "img/login_logo.50305539.png";